import Event from '../../classes/event';
import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

export default function goToL7D(asset?: Event | null) {
  const { media } = store.getState();
  if (asset?.channel?.id) {
    store.dispatch(
      pushRoute({
        route: { Page: Pages.LAST_SHOWS_CHANNEL },
        params: {
          current: {
            channelCode: asset?.channel.code,
            channelId: asset?.channel.id,
          },
          push: true,
          stack: { position: !media.live ? media.currentTime : undefined },
        },
      })
    );
  }
}
